import { ICurrentUserProvider } from '@cp/entities/dialog';
import { DialogMemberType, MemberUser } from '@youhelp-ru/core';

interface IMemberUser {
  readonly id: number;
  readonly type: DialogMemberType;
}

export interface DialogUserStorage {
  set(u: IMemberUser): void;
  get(): IMemberUser | null;
  reset(): void;
}

export class DialogUserService implements ICurrentUserProvider {
  #storage: DialogUserStorage;
  #loggedInUserProvider: () => MemberUser | null;

  constructor(storage: DialogUserStorage, loggedInUserProvider: () => MemberUser | null) {
    this.#loggedInUserProvider = loggedInUserProvider;
    this.#storage = storage;
    const u = storage.get();
    if (!u) {
      const currentMemberUser = this.#loggedInUserProvider();
      if (currentMemberUser) {
        this.#storage.set(currentMemberUser);
      }
    }
  }

  getUser() {
    const mu = this.#storage.get();
    return mu ? MemberUser.create(mu) : mu;
  }

  setUser(user: MemberUser) {
    this.#storage.set(user);
  }

  reset() {
    this.#storage.reset();
  }
}
